export default __webpack_public_path__ + "static/media/auth0-roles-user.8da577c2.png";